module.exports = __webpack_public_path__ + "static/media/iconIos.8d5c755b.png";